/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ChatDto,
  ChatDtoPagination,
  ChatPostDto,
  ChatPostDtoPagination,
  CreateChat,
  CreateChatPost,
  DeleteChatParams,
  DeletePostParams,
  GetChatByIdParams,
  GetChatPostsParams,
  GetChatsParams,
  GetDirectChatIdParams,
  GetDirectChatIdResponse,
  GetFeedPostParams,
  GetFeedPostsForUserParams,
  GetFeedPostsParams,
  GetLastReadPostIdParams,
  JoinPublicGroupParams,
  SoftDeleteChatMessageParams,
  ToggleInactivateChatParams,
  ToggleMuteChatParams,
  ToggleReactionParams,
  ToggleSubscribeFeedRequest,
  UpdateChat,
  UpdateChatPostParam,
  UpdateReadMessageRequest
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetChatsUrl = (params?: GetChatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["chatTypeFilters"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetChats?${stringifiedParams}` : `/api/Chat/GetChats`
}

export const getChats = async (params?: GetChatsParams, options?: RequestInit): Promise<ChatDtoPagination> => {
  
  return customInstance<ChatDtoPagination>(getGetChatsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetChatsQueryKey = (params?: GetChatsParams,) => {
    return [
    `/api/Chat/GetChats`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetChatsQueryOptions = <TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(params?: GetChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChats>>> = ({ signal }) => getChats(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetChatsQueryResult = NonNullable<Awaited<ReturnType<typeof getChats>>>
export type GetChatsQueryError = ErrorType<unknown>


export function useGetChats<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params: undefined |  GetChatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChats>>,
          TError,
          Awaited<ReturnType<typeof getChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChats<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params?: GetChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChats>>,
          TError,
          Awaited<ReturnType<typeof getChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChats<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params?: GetChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetChats<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params?: GetChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetChatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetChatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(params?: GetChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChats>>> = ({ signal }) => getChats(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetChatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChats>>>
export type GetChatsSuspenseQueryError = ErrorType<unknown>


export function useGetChatsSuspense<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params: undefined |  GetChatsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChatsSuspense<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params?: GetChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChatsSuspense<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params?: GetChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetChatsSuspense<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params?: GetChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetChatsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCreateChatUrl = () => {


  

  return `/api/Chat/CreateChat`
}

export const createChat = async (createChat: CreateChat, options?: RequestInit): Promise<ChatDto> => {
  
  return customInstance<ChatDto>(getCreateChatUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createChat,)
  }
);}




export const getCreateChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChat>>, TError,{data: BodyType<CreateChat>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createChat>>, TError,{data: BodyType<CreateChat>}, TContext> => {

const mutationKey = ['createChat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChat>>, {data: BodyType<CreateChat>}> = (props) => {
          const {data} = props ?? {};

          return  createChat(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateChatMutationResult = NonNullable<Awaited<ReturnType<typeof createChat>>>
    export type CreateChatMutationBody = BodyType<CreateChat>
    export type CreateChatMutationError = ErrorType<unknown>

    export const useCreateChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChat>>, TError,{data: BodyType<CreateChat>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createChat>>,
        TError,
        {data: BodyType<CreateChat>},
        TContext
      > => {

      const mutationOptions = getCreateChatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetChatByIdUrl = (params: GetChatByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetChatById?${stringifiedParams}` : `/api/Chat/GetChatById`
}

export const getChatById = async (params: GetChatByIdParams, options?: RequestInit): Promise<ChatDto> => {
  
  return customInstance<ChatDto>(getGetChatByIdUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetChatByIdQueryKey = (params?: GetChatByIdParams,) => {
    return [
    `/api/Chat/GetChatById`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetChatByIdQueryOptions = <TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(params: GetChatByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatById>>> = ({ signal }) => getChatById(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetChatByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getChatById>>>
export type GetChatByIdQueryError = ErrorType<unknown>


export function useGetChatById<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatById>>,
          TError,
          Awaited<ReturnType<typeof getChatById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChatById<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatById>>,
          TError,
          Awaited<ReturnType<typeof getChatById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChatById<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetChatById<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetChatByIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetChatByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(params: GetChatByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatById>>> = ({ signal }) => getChatById(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetChatByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChatById>>>
export type GetChatByIdSuspenseQueryError = ErrorType<unknown>


export function useGetChatByIdSuspense<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChatByIdSuspense<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChatByIdSuspense<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetChatByIdSuspense<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetChatByIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCreateChatPostUrl = () => {


  

  return `/api/Chat/CreateChatPost`
}

export const createChatPost = async (createChatPost: CreateChatPost, options?: RequestInit): Promise<number> => {
  
  return customInstance<number>(getCreateChatPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createChatPost,)
  }
);}




export const getCreateChatPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChatPost>>, TError,{data: BodyType<CreateChatPost>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createChatPost>>, TError,{data: BodyType<CreateChatPost>}, TContext> => {

const mutationKey = ['createChatPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChatPost>>, {data: BodyType<CreateChatPost>}> = (props) => {
          const {data} = props ?? {};

          return  createChatPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateChatPostMutationResult = NonNullable<Awaited<ReturnType<typeof createChatPost>>>
    export type CreateChatPostMutationBody = BodyType<CreateChatPost>
    export type CreateChatPostMutationError = ErrorType<unknown>

    export const useCreateChatPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChatPost>>, TError,{data: BodyType<CreateChatPost>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createChatPost>>,
        TError,
        {data: BodyType<CreateChatPost>},
        TContext
      > => {

      const mutationOptions = getCreateChatPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUpdateMessageContentUrl = () => {


  

  return `/api/Chat/UpdateMessageContent`
}

export const updateMessageContent = async (updateChatPostParam: UpdateChatPostParam, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getUpdateMessageContentUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateChatPostParam,)
  }
);}




export const getUpdateMessageContentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMessageContent>>, TError,{data: BodyType<UpdateChatPostParam>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMessageContent>>, TError,{data: BodyType<UpdateChatPostParam>}, TContext> => {

const mutationKey = ['updateMessageContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMessageContent>>, {data: BodyType<UpdateChatPostParam>}> = (props) => {
          const {data} = props ?? {};

          return  updateMessageContent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMessageContentMutationResult = NonNullable<Awaited<ReturnType<typeof updateMessageContent>>>
    export type UpdateMessageContentMutationBody = BodyType<UpdateChatPostParam>
    export type UpdateMessageContentMutationError = ErrorType<unknown>

    export const useUpdateMessageContent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMessageContent>>, TError,{data: BodyType<UpdateChatPostParam>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMessageContent>>,
        TError,
        {data: BodyType<UpdateChatPostParam>},
        TContext
      > => {

      const mutationOptions = getUpdateMessageContentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUpdateChatUrl = () => {


  

  return `/api/Chat/UpdateChat`
}

export const updateChat = async (updateChat: UpdateChat, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getUpdateChatUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateChat,)
  }
);}




export const getUpdateChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChat>>, TError,{data: BodyType<UpdateChat>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateChat>>, TError,{data: BodyType<UpdateChat>}, TContext> => {

const mutationKey = ['updateChat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChat>>, {data: BodyType<UpdateChat>}> = (props) => {
          const {data} = props ?? {};

          return  updateChat(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateChatMutationResult = NonNullable<Awaited<ReturnType<typeof updateChat>>>
    export type UpdateChatMutationBody = BodyType<UpdateChat>
    export type UpdateChatMutationError = ErrorType<unknown>

    export const useUpdateChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChat>>, TError,{data: BodyType<UpdateChat>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateChat>>,
        TError,
        {data: BodyType<UpdateChat>},
        TContext
      > => {

      const mutationOptions = getUpdateChatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getDeleteChatUrl = (params?: DeleteChatParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/DeleteChat?${stringifiedParams}` : `/api/Chat/DeleteChat`
}

export const deleteChat = async (params?: DeleteChatParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getDeleteChatUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getDeleteChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChat>>, TError,{params?: DeleteChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteChat>>, TError,{params?: DeleteChatParams}, TContext> => {

const mutationKey = ['deleteChat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteChat>>, {params?: DeleteChatParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteChat(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteChatMutationResult = NonNullable<Awaited<ReturnType<typeof deleteChat>>>
    
    export type DeleteChatMutationError = ErrorType<unknown>

    export const useDeleteChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChat>>, TError,{params?: DeleteChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteChat>>,
        TError,
        {params?: DeleteChatParams},
        TContext
      > => {

      const mutationOptions = getDeleteChatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetUnreadCountUrl = () => {


  

  return `/api/Chat/GetUnreadCount`
}

export const getUnreadCount = async ( options?: RequestInit): Promise<number> => {
  
  return customInstance<number>(getGetUnreadCountUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUnreadCountQueryKey = () => {
    return [
    `/api/Chat/GetUnreadCount`
    ] as const;
    }

    
export const getGetUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnreadCountQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadCount>>> = ({ signal }) => getUnreadCount({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadCount>>>
export type GetUnreadCountQueryError = ErrorType<unknown>


export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetUnreadCountSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnreadCountQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadCount>>> = ({ signal }) => getUnreadCount({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUnreadCountSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadCount>>>
export type GetUnreadCountSuspenseQueryError = ErrorType<unknown>


export function useGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUnreadCountSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetChatPostsUrl = (params?: GetChatPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetChatPosts?${stringifiedParams}` : `/api/Chat/GetChatPosts`
}

export const getChatPosts = async (params?: GetChatPostsParams, options?: RequestInit): Promise<ChatPostDtoPagination> => {
  
  return customInstance<ChatPostDtoPagination>(getGetChatPostsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetChatPostsQueryKey = (params?: GetChatPostsParams,) => {
    return [
    `/api/Chat/GetChatPosts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetChatPostsQueryOptions = <TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(params?: GetChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatPostsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatPosts>>> = ({ signal }) => getChatPosts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetChatPostsQueryResult = NonNullable<Awaited<ReturnType<typeof getChatPosts>>>
export type GetChatPostsQueryError = ErrorType<unknown>


export function useGetChatPosts<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetChatPostsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatPosts>>,
          TError,
          Awaited<ReturnType<typeof getChatPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChatPosts<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params?: GetChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatPosts>>,
          TError,
          Awaited<ReturnType<typeof getChatPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChatPosts<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params?: GetChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetChatPosts<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params?: GetChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetChatPostsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetChatPostsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(params?: GetChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatPostsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatPosts>>> = ({ signal }) => getChatPosts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetChatPostsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChatPosts>>>
export type GetChatPostsSuspenseQueryError = ErrorType<unknown>


export function useGetChatPostsSuspense<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetChatPostsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChatPostsSuspense<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params?: GetChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChatPostsSuspense<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params?: GetChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetChatPostsSuspense<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params?: GetChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetChatPostsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUpdateReadMessageUrl = () => {


  

  return `/api/Chat/UpdateReadMessage`
}

export const updateReadMessage = async (updateReadMessageRequest: UpdateReadMessageRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getUpdateReadMessageUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateReadMessageRequest,)
  }
);}




export const getUpdateReadMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReadMessage>>, TError,{data: BodyType<UpdateReadMessageRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReadMessage>>, TError,{data: BodyType<UpdateReadMessageRequest>}, TContext> => {

const mutationKey = ['updateReadMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReadMessage>>, {data: BodyType<UpdateReadMessageRequest>}> = (props) => {
          const {data} = props ?? {};

          return  updateReadMessage(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateReadMessageMutationResult = NonNullable<Awaited<ReturnType<typeof updateReadMessage>>>
    export type UpdateReadMessageMutationBody = BodyType<UpdateReadMessageRequest>
    export type UpdateReadMessageMutationError = ErrorType<unknown>

    export const useUpdateReadMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReadMessage>>, TError,{data: BodyType<UpdateReadMessageRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateReadMessage>>,
        TError,
        {data: BodyType<UpdateReadMessageRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateReadMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getJoinPublicGroupUrl = (params: JoinPublicGroupParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/JoinPublicGroup?${stringifiedParams}` : `/api/Chat/JoinPublicGroup`
}

export const joinPublicGroup = async (params: JoinPublicGroupParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getJoinPublicGroupUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getJoinPublicGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinPublicGroup>>, TError,{params: JoinPublicGroupParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof joinPublicGroup>>, TError,{params: JoinPublicGroupParams}, TContext> => {

const mutationKey = ['joinPublicGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinPublicGroup>>, {params: JoinPublicGroupParams}> = (props) => {
          const {params} = props ?? {};

          return  joinPublicGroup(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type JoinPublicGroupMutationResult = NonNullable<Awaited<ReturnType<typeof joinPublicGroup>>>
    
    export type JoinPublicGroupMutationError = ErrorType<unknown>

    export const useJoinPublicGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinPublicGroup>>, TError,{params: JoinPublicGroupParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof joinPublicGroup>>,
        TError,
        {params: JoinPublicGroupParams},
        TContext
      > => {

      const mutationOptions = getJoinPublicGroupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getToggleMuteChatUrl = (params: ToggleMuteChatParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/ToggleMuteChat?${stringifiedParams}` : `/api/Chat/ToggleMuteChat`
}

export const toggleMuteChat = async (params: ToggleMuteChatParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getToggleMuteChatUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getToggleMuteChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleMuteChat>>, TError,{params: ToggleMuteChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleMuteChat>>, TError,{params: ToggleMuteChatParams}, TContext> => {

const mutationKey = ['toggleMuteChat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleMuteChat>>, {params: ToggleMuteChatParams}> = (props) => {
          const {params} = props ?? {};

          return  toggleMuteChat(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleMuteChatMutationResult = NonNullable<Awaited<ReturnType<typeof toggleMuteChat>>>
    
    export type ToggleMuteChatMutationError = ErrorType<unknown>

    export const useToggleMuteChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleMuteChat>>, TError,{params: ToggleMuteChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleMuteChat>>,
        TError,
        {params: ToggleMuteChatParams},
        TContext
      > => {

      const mutationOptions = getToggleMuteChatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getToggleInactivateChatUrl = (params: ToggleInactivateChatParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/ToggleInactivateChat?${stringifiedParams}` : `/api/Chat/ToggleInactivateChat`
}

export const toggleInactivateChat = async (params: ToggleInactivateChatParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getToggleInactivateChatUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getToggleInactivateChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleInactivateChat>>, TError,{params: ToggleInactivateChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleInactivateChat>>, TError,{params: ToggleInactivateChatParams}, TContext> => {

const mutationKey = ['toggleInactivateChat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleInactivateChat>>, {params: ToggleInactivateChatParams}> = (props) => {
          const {params} = props ?? {};

          return  toggleInactivateChat(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleInactivateChatMutationResult = NonNullable<Awaited<ReturnType<typeof toggleInactivateChat>>>
    
    export type ToggleInactivateChatMutationError = ErrorType<unknown>

    export const useToggleInactivateChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleInactivateChat>>, TError,{params: ToggleInactivateChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleInactivateChat>>,
        TError,
        {params: ToggleInactivateChatParams},
        TContext
      > => {

      const mutationOptions = getToggleInactivateChatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUserHasArchivedChatUrl = () => {


  

  return `/api/Chat/UserHasArchivedChat`
}

export const userHasArchivedChat = async ( options?: RequestInit): Promise<boolean> => {
  
  return customInstance<boolean>(getUserHasArchivedChatUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserHasArchivedChatQueryKey = () => {
    return [
    `/api/Chat/UserHasArchivedChat`
    ] as const;
    }

    
export const getUserHasArchivedChatQueryOptions = <TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserHasArchivedChatQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userHasArchivedChat>>> = ({ signal }) => userHasArchivedChat({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserHasArchivedChatQueryResult = NonNullable<Awaited<ReturnType<typeof userHasArchivedChat>>>
export type UserHasArchivedChatQueryError = ErrorType<unknown>


export function useUserHasArchivedChat<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userHasArchivedChat>>,
          TError,
          Awaited<ReturnType<typeof userHasArchivedChat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserHasArchivedChat<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userHasArchivedChat>>,
          TError,
          Awaited<ReturnType<typeof userHasArchivedChat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserHasArchivedChat<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserHasArchivedChat<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserHasArchivedChatQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserHasArchivedChatSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserHasArchivedChatQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userHasArchivedChat>>> = ({ signal }) => userHasArchivedChat({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserHasArchivedChatSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userHasArchivedChat>>>
export type UserHasArchivedChatSuspenseQueryError = ErrorType<unknown>


export function useUserHasArchivedChatSuspense<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserHasArchivedChatSuspense<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserHasArchivedChatSuspense<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserHasArchivedChatSuspense<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserHasArchivedChatSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLastReadPostIdUrl = (params?: GetLastReadPostIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetLastReadPostId?${stringifiedParams}` : `/api/Chat/GetLastReadPostId`
}

export const getLastReadPostId = async (params?: GetLastReadPostIdParams, options?: RequestInit): Promise<number | null> => {
  
  return customInstance<number | null>(getGetLastReadPostIdUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetLastReadPostIdQueryKey = (params?: GetLastReadPostIdParams,) => {
    return [
    `/api/Chat/GetLastReadPostId`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLastReadPostIdQueryOptions = <TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(params?: GetLastReadPostIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLastReadPostIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLastReadPostId>>> = ({ signal }) => getLastReadPostId(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLastReadPostIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLastReadPostId>>>
export type GetLastReadPostIdQueryError = ErrorType<unknown>


export function useGetLastReadPostId<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLastReadPostIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLastReadPostId>>,
          TError,
          Awaited<ReturnType<typeof getLastReadPostId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLastReadPostId<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: GetLastReadPostIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLastReadPostId>>,
          TError,
          Awaited<ReturnType<typeof getLastReadPostId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLastReadPostId<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: GetLastReadPostIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLastReadPostId<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: GetLastReadPostIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLastReadPostIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLastReadPostIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(params?: GetLastReadPostIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLastReadPostIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLastReadPostId>>> = ({ signal }) => getLastReadPostId(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLastReadPostIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLastReadPostId>>>
export type GetLastReadPostIdSuspenseQueryError = ErrorType<unknown>


export function useGetLastReadPostIdSuspense<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLastReadPostIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLastReadPostIdSuspense<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: GetLastReadPostIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLastReadPostIdSuspense<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: GetLastReadPostIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLastReadPostIdSuspense<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: GetLastReadPostIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLastReadPostIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserCanCreateChatsUrl = () => {


  

  return `/api/Chat/UserCanCreateChats`
}

export const userCanCreateChats = async ( options?: RequestInit): Promise<boolean> => {
  
  return customInstance<boolean>(getUserCanCreateChatsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserCanCreateChatsQueryKey = () => {
    return [
    `/api/Chat/UserCanCreateChats`
    ] as const;
    }

    
export const getUserCanCreateChatsQueryOptions = <TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserCanCreateChatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userCanCreateChats>>> = ({ signal }) => userCanCreateChats({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserCanCreateChatsQueryResult = NonNullable<Awaited<ReturnType<typeof userCanCreateChats>>>
export type UserCanCreateChatsQueryError = ErrorType<unknown>


export function useUserCanCreateChats<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userCanCreateChats>>,
          TError,
          Awaited<ReturnType<typeof userCanCreateChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserCanCreateChats<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userCanCreateChats>>,
          TError,
          Awaited<ReturnType<typeof userCanCreateChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserCanCreateChats<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserCanCreateChats<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserCanCreateChatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserCanCreateChatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserCanCreateChatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userCanCreateChats>>> = ({ signal }) => userCanCreateChats({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserCanCreateChatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userCanCreateChats>>>
export type UserCanCreateChatsSuspenseQueryError = ErrorType<unknown>


export function useUserCanCreateChatsSuspense<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserCanCreateChatsSuspense<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserCanCreateChatsSuspense<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserCanCreateChatsSuspense<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserCanCreateChatsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDirectChatIdUrl = (params?: GetDirectChatIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetDirectChatId?${stringifiedParams}` : `/api/Chat/GetDirectChatId`
}

export const getDirectChatId = async (params?: GetDirectChatIdParams, options?: RequestInit): Promise<GetDirectChatIdResponse> => {
  
  return customInstance<GetDirectChatIdResponse>(getGetDirectChatIdUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetDirectChatIdQueryKey = (params?: GetDirectChatIdParams,) => {
    return [
    `/api/Chat/GetDirectChatId`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDirectChatIdQueryOptions = <TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(params?: GetDirectChatIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDirectChatIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDirectChatId>>> = ({ signal }) => getDirectChatId(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDirectChatIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDirectChatId>>>
export type GetDirectChatIdQueryError = ErrorType<unknown>


export function useGetDirectChatId<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetDirectChatIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDirectChatId>>,
          TError,
          Awaited<ReturnType<typeof getDirectChatId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDirectChatId<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params?: GetDirectChatIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDirectChatId>>,
          TError,
          Awaited<ReturnType<typeof getDirectChatId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDirectChatId<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params?: GetDirectChatIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDirectChatId<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params?: GetDirectChatIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDirectChatIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDirectChatIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(params?: GetDirectChatIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDirectChatIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDirectChatId>>> = ({ signal }) => getDirectChatId(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDirectChatIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDirectChatId>>>
export type GetDirectChatIdSuspenseQueryError = ErrorType<unknown>


export function useGetDirectChatIdSuspense<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetDirectChatIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDirectChatIdSuspense<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params?: GetDirectChatIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDirectChatIdSuspense<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params?: GetDirectChatIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDirectChatIdSuspense<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params?: GetDirectChatIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDirectChatIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSoftDeleteChatMessageUrl = (params?: SoftDeleteChatMessageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/SoftDeleteChatMessage?${stringifiedParams}` : `/api/Chat/SoftDeleteChatMessage`
}

export const softDeleteChatMessage = async (params?: SoftDeleteChatMessageParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getSoftDeleteChatMessageUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getSoftDeleteChatMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof softDeleteChatMessage>>, TError,{params?: SoftDeleteChatMessageParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof softDeleteChatMessage>>, TError,{params?: SoftDeleteChatMessageParams}, TContext> => {

const mutationKey = ['softDeleteChatMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof softDeleteChatMessage>>, {params?: SoftDeleteChatMessageParams}> = (props) => {
          const {params} = props ?? {};

          return  softDeleteChatMessage(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SoftDeleteChatMessageMutationResult = NonNullable<Awaited<ReturnType<typeof softDeleteChatMessage>>>
    
    export type SoftDeleteChatMessageMutationError = ErrorType<unknown>

    export const useSoftDeleteChatMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof softDeleteChatMessage>>, TError,{params?: SoftDeleteChatMessageParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof softDeleteChatMessage>>,
        TError,
        {params?: SoftDeleteChatMessageParams},
        TContext
      > => {

      const mutationOptions = getSoftDeleteChatMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetFeedPostsUrl = (params?: GetFeedPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetFeedPosts?${stringifiedParams}` : `/api/Chat/GetFeedPosts`
}

export const getFeedPosts = async (params?: GetFeedPostsParams, options?: RequestInit): Promise<ChatPostDtoPagination> => {
  
  return customInstance<ChatPostDtoPagination>(getGetFeedPostsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetFeedPostsQueryKey = (params?: GetFeedPostsParams,) => {
    return [
    `/api/Chat/GetFeedPosts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetFeedPostsQueryOptions = <TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(params?: GetFeedPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedPostsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedPosts>>> = ({ signal }) => getFeedPosts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFeedPostsQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedPosts>>>
export type GetFeedPostsQueryError = ErrorType<unknown>


export function useGetFeedPosts<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFeedPostsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedPosts>>,
          TError,
          Awaited<ReturnType<typeof getFeedPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeedPosts<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedPosts>>,
          TError,
          Awaited<ReturnType<typeof getFeedPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeedPosts<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFeedPosts<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFeedPostsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFeedPostsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(params?: GetFeedPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedPostsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedPosts>>> = ({ signal }) => getFeedPosts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFeedPostsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedPosts>>>
export type GetFeedPostsSuspenseQueryError = ErrorType<unknown>


export function useGetFeedPostsSuspense<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFeedPostsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeedPostsSuspense<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeedPostsSuspense<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFeedPostsSuspense<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFeedPostsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFeedPostsForUserUrl = (params: GetFeedPostsForUserParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetFeedPostsForUser?${stringifiedParams}` : `/api/Chat/GetFeedPostsForUser`
}

export const getFeedPostsForUser = async (params: GetFeedPostsForUserParams, options?: RequestInit): Promise<ChatPostDtoPagination> => {
  
  return customInstance<ChatPostDtoPagination>(getGetFeedPostsForUserUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetFeedPostsForUserQueryKey = (params?: GetFeedPostsForUserParams,) => {
    return [
    `/api/Chat/GetFeedPostsForUser`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetFeedPostsForUserQueryOptions = <TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(params: GetFeedPostsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedPostsForUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedPostsForUser>>> = ({ signal }) => getFeedPostsForUser(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFeedPostsForUserQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedPostsForUser>>>
export type GetFeedPostsForUserQueryError = ErrorType<unknown>


export function useGetFeedPostsForUser<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedPostsForUser>>,
          TError,
          Awaited<ReturnType<typeof getFeedPostsForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeedPostsForUser<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedPostsForUser>>,
          TError,
          Awaited<ReturnType<typeof getFeedPostsForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeedPostsForUser<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFeedPostsForUser<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFeedPostsForUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFeedPostsForUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(params: GetFeedPostsForUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedPostsForUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedPostsForUser>>> = ({ signal }) => getFeedPostsForUser(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFeedPostsForUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedPostsForUser>>>
export type GetFeedPostsForUserSuspenseQueryError = ErrorType<unknown>


export function useGetFeedPostsForUserSuspense<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeedPostsForUserSuspense<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeedPostsForUserSuspense<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFeedPostsForUserSuspense<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFeedPostsForUserSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFeedPostUrl = (params?: GetFeedPostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetFeedPost?${stringifiedParams}` : `/api/Chat/GetFeedPost`
}

export const getFeedPost = async (params?: GetFeedPostParams, options?: RequestInit): Promise<ChatPostDto> => {
  
  return customInstance<ChatPostDto>(getGetFeedPostUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetFeedPostQueryKey = (params?: GetFeedPostParams,) => {
    return [
    `/api/Chat/GetFeedPost`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetFeedPostQueryOptions = <TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(params?: GetFeedPostParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedPostQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedPost>>> = ({ signal }) => getFeedPost(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFeedPostQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedPost>>>
export type GetFeedPostQueryError = ErrorType<unknown>


export function useGetFeedPost<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFeedPostParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedPost>>,
          TError,
          Awaited<ReturnType<typeof getFeedPost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeedPost<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedPost>>,
          TError,
          Awaited<ReturnType<typeof getFeedPost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeedPost<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFeedPost<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFeedPostQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFeedPostSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(params?: GetFeedPostParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedPostQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedPost>>> = ({ signal }) => getFeedPost(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFeedPostSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedPost>>>
export type GetFeedPostSuspenseQueryError = ErrorType<unknown>


export function useGetFeedPostSuspense<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFeedPostParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeedPostSuspense<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeedPostSuspense<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFeedPostSuspense<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFeedPostSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDeletePostUrl = (params?: DeletePostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/DeletePost?${stringifiedParams}` : `/api/Chat/DeletePost`
}

export const deletePost = async (params?: DeletePostParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getDeletePostUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getDeletePostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePost>>, TError,{params?: DeletePostParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePost>>, TError,{params?: DeletePostParams}, TContext> => {

const mutationKey = ['deletePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePost>>, {params?: DeletePostParams}> = (props) => {
          const {params} = props ?? {};

          return  deletePost(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePostMutationResult = NonNullable<Awaited<ReturnType<typeof deletePost>>>
    
    export type DeletePostMutationError = ErrorType<unknown>

    export const useDeletePost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePost>>, TError,{params?: DeletePostParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePost>>,
        TError,
        {params?: DeletePostParams},
        TContext
      > => {

      const mutationOptions = getDeletePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getToggleReactionUrl = (params?: ToggleReactionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/ToggleReaction?${stringifiedParams}` : `/api/Chat/ToggleReaction`
}

export const toggleReaction = async (params?: ToggleReactionParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getToggleReactionUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getToggleReactionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleReaction>>, TError,{params?: ToggleReactionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleReaction>>, TError,{params?: ToggleReactionParams}, TContext> => {

const mutationKey = ['toggleReaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleReaction>>, {params?: ToggleReactionParams}> = (props) => {
          const {params} = props ?? {};

          return  toggleReaction(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleReactionMutationResult = NonNullable<Awaited<ReturnType<typeof toggleReaction>>>
    
    export type ToggleReactionMutationError = ErrorType<unknown>

    export const useToggleReaction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleReaction>>, TError,{params?: ToggleReactionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleReaction>>,
        TError,
        {params?: ToggleReactionParams},
        TContext
      > => {

      const mutationOptions = getToggleReactionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getToggleSubscribeFeedUrl = () => {


  

  return `/api/Chat/ToggleSubscribeFeed`
}

export const toggleSubscribeFeed = async (toggleSubscribeFeedRequest: ToggleSubscribeFeedRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getToggleSubscribeFeedUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      toggleSubscribeFeedRequest,)
  }
);}




export const getToggleSubscribeFeedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleSubscribeFeed>>, TError,{data: BodyType<ToggleSubscribeFeedRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleSubscribeFeed>>, TError,{data: BodyType<ToggleSubscribeFeedRequest>}, TContext> => {

const mutationKey = ['toggleSubscribeFeed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleSubscribeFeed>>, {data: BodyType<ToggleSubscribeFeedRequest>}> = (props) => {
          const {data} = props ?? {};

          return  toggleSubscribeFeed(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleSubscribeFeedMutationResult = NonNullable<Awaited<ReturnType<typeof toggleSubscribeFeed>>>
    export type ToggleSubscribeFeedMutationBody = BodyType<ToggleSubscribeFeedRequest>
    export type ToggleSubscribeFeedMutationError = ErrorType<unknown>

    export const useToggleSubscribeFeed = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleSubscribeFeed>>, TError,{data: BodyType<ToggleSubscribeFeedRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleSubscribeFeed>>,
        TError,
        {data: BodyType<ToggleSubscribeFeedRequest>},
        TContext
      > => {

      const mutationOptions = getToggleSubscribeFeedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    